import React from 'react';

import { getDatasourceContentUrl } from '../../../datasource/components/cards/DatasourceCard';
import { DataSources } from '../../../datasource/resources/Datasources';
import { IDataConnectionInfo } from '../../../ts/models/IDataConnectionInfo';
import { ConnectionDisplay } from '../ListView/DataConnectionComponents';
import { SpacesSiteUrls } from '../SpacesSiteUrls';
import { CardViewStyles } from './CardViewStyles';
import { ContentCard } from './ContentCard';
import { DataconnectionThumbnail } from './DataconnectionThumbnail';

export class DataconnectionCard extends ContentCard {

  public render() {

    const dataconnection = this.props.content as IDataConnectionInfo;
    const metadata = ConnectionDisplay.getDisplayMetadata(dataconnection, this.props.urls);
    const contentUrl = getDataConnectionContentUrl(
        this.props.urls,
        dataconnection,
        this.props.inWorkbookDatasourcesSubspace,
        this.props.inDatasourceConnectionsSubspace);
    const translatedName = ConnectionDisplay.translatedText(metadata);

    return (
      <div className={CardViewStyles.Card}>
        <DataconnectionThumbnail
          dataconnection={this.props.content as IDataConnectionInfo}
          metadata={metadata}
          datasourceContentUrl={contentUrl}
          hoveredOrSelected={this.props.hoveredOrSelected}
          urls={this.props.urls}
        />
        <div className={CardViewStyles.ActionRow}>
        { translatedName.nameUnavailable
          ? <span className={CardViewStyles.ActionRowNameMissing} title={translatedName.connectionName}>{translatedName.connectionName}</span>
          : <span className={CardViewStyles.ActionRowName} title={translatedName.connectionName}>{translatedName.connectionName}</span>
        }
          { this.renderActionsMenu() }
        </div>
      </div>
    );
  }
}

function getDataConnectionContentUrl(
    urls: SpacesSiteUrls,
    dataconnection: IDataConnectionInfo,
    inWorkbookDatasourcesSubspace: boolean,
    inDatasourceConnectionsSubspace: boolean,
): string {

  // If we're already in a data source place, the card href link to where we already are, so
  // don't make it a link.
  if (inDatasourceConnectionsSubspace) {
    return undefined;
  }

  // Otherwise, the connection links to wherever the data source is.
  const datasourceInfo = DataSources.getDatasourceInfoFromDataConnection(dataconnection);
  return getDatasourceContentUrl(urls, datasourceInfo, inWorkbookDatasourcesSubspace);
}
